<script setup lang="ts">
import { UiText } from "@shopexperts/shared";

withDefaults(defineProps<{
    title: string;
    content?: string | null;
    fallback?: string;
    html?: boolean;
}>(), {
    content: null,
    fallback: "",
    html: false,
});
</script>

<template>
    <section class="flex flex-col gap-2">
        <UiText as="h3" variant="p" class="font-semibold text-se-dark">
            {{ title }}
        </UiText>
        <div class="rounded-md border bg-se-gray-300/25 border-se-gray-300 p-4">
            <div v-if="content" class="se-message-prose text-se-dark">
                <div v-if="html" v-html="content" />
                <p v-else class="whitespace-pre-wrap">{{ content }}</p>
            </div>
            <UiText v-else-if="fallback" as="p" variant="p" class="text-se-gray-500">
                {{ fallback }}
            </UiText>
        </div>
    </section>
</template>
